import { useTranslation } from 'react-i18next';
import { Zap } from 'lucide-react';
import LanguageSwitcher from '@/components/LanguageSwitcher';

export default function Navigation() {
  const { t } = useTranslation();

  return (
    <nav className="glass-nav sticky top-0 z-50 py-4">
      <div className="container mx-auto px-6 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Zap className="w-7 h-7 text-primary" />
          <span className="text-2xl font-light text-primary" style={{ fontFamily: 'Outfit' }}>{t('nav.brand')}</span>
        </div>
        <div className="hidden md:flex items-center gap-6">
          <a href="#how-it-works" className="text-sm font-medium text-foreground hover:text-primary transition-colors">{t('nav.howItWorks')}</a>
          <a href="#home-types" className="text-sm font-medium text-foreground hover:text-primary transition-colors">{t('nav.homeTypes')}</a>
          <a href="#pricing" className="text-sm font-medium text-foreground hover:text-primary transition-colors">{t('nav.pricing')}</a>
          <a href="#faq" className="text-sm font-medium text-foreground hover:text-primary transition-colors">{t('nav.faq')}</a>
          <LanguageSwitcher />
          <button 
            onClick={() => {
              if (window.pwTrack) window.pwTrack('cta_to_pricing', { source: 'nav' });
              const el = document.querySelector('[data-testid="pricing-section"]');
              if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }} 
            className="btn-primary px-6 py-2.5 rounded-md font-medium text-sm"
            data-testid="nav-start-scan-btn"
          >
            Start Mijn Powersure
          </button>
        </div>
      </div>
    </nav>
  );
}
